import { columnSearch, sorteColum } from "@/utils/columnSearch";

// export const TableColumn = () => [
//   {
//     title: '始发营运区',
//     dataIndex: 'originProvinceArea',
//     align: 'center',
//     // ellipsis: true,
//     fixed: 'left',
//     width: 200,
//     ...columnSearch('originProvinceArea'),
//   },
//   {
//     title: '星期一',
//     dataIndex: 'calcWeight0',
//     align: 'right',
//     // ellipsis: true,
//     // width: 100,
//     sorter: sorteColum(`calcWeight0`, true),
//   },
//   {
//     title: '星期二',
//     dataIndex: 'calcWeight1',
//     align: 'right',
//     // ellipsis: true,
//     // width: 100,
//     sorter: sorteColum(`calcWeight1`, true),
//   },
//   {
//     title: '星期三',
//     dataIndex: 'calcWeight2',
//     align: 'right',
//     // ellipsis: true,
//     // width: 100,
//     sorter: sorteColum(`calcWeight2`, true),
//   },
//   {
//     title: '星期四',
//     dataIndex: 'calcWeight3',
//     align: 'right',
//     // ellipsis: true,
//     // width: 100,
//     sorter: sorteColum(`calcWeight3`, true),
//   },
//   {
//     title: '星期五',
//     dataIndex: 'calcWeight4',
//     align: 'right',
//     // ellipsis: true,
//     // width: 100,
//     sorter: sorteColum(`calcWeight4`, true),
//   },
//   {
//     title: '星期六',
//     dataIndex: 'calcWeight5',
//     align: 'right',
//     // ellipsis: true,
//     // width: 100,
//     sorter: sorteColum(`calcWeight5`, true),
//   },
//   {
//     title: '星期天',
//     dataIndex: 'calcWeight6',
//     align: 'right',
//     // ellipsis: true,
//     // width: 100,
//     sorter: sorteColum(`calcWeight6`, true),
//   },
// ];

export const initalColumnCof = [
  // {
  //   title: '始发营运区',
  //   dataIndex: 'originProvinceArea',
  //   align: 'center',
  //   // ellipsis: true,
  //   fixed: 'left',
  //   width: 200,
  //   ...columnSearch('originProvinceArea'),
  // },
  {
    title: '星期一',
    // dataIndex: 'calcWeight0',
    // align: 'right',
    // ellipsis: true,
    // width: 100,
    // sorter: sorteColum(`calcWeight0`, true),
  },
  {
    title: '星期二',
    // dataIndex: 'calcWeight1',
    // align: 'right',
    // // ellipsis: true,
    // // width: 100,
    // sorter: sorteColum(`calcWeight1`, true),
  },
  {
    title: '星期三',
    // dataIndex: 'calcWeight2',
    // align: 'right',
    // // ellipsis: true,
    // // width: 100,
    // sorter: sorteColum(`calcWeight2`, true),
  },
  {
    title: '星期四',
    // dataIndex: 'calcWeight3',
    // align: 'right',
    // // ellipsis: true,
    // // width: 100,
    // sorter: sorteColum(`calcWeight3`, true),
  },
  {
    title: '星期五',
    // dataIndex: 'calcWeight4',
    // align: 'right',
    // // ellipsis: true,
    // // width: 100,
    // sorter: sorteColum(`calcWeight4`, true),
  },
  {
    title: '星期六',
    // dataIndex: 'calcWeight5',
    // align: 'right',
    // // ellipsis: true,
    // // width: 100,
    // sorter: sorteColum(`calcWeight5`, true),
  },
  {
    title: '星期天',
    // dataIndex: 'calcWeight6',
    // align: 'right',
    // // ellipsis: true,
    // // width: 100,
    // sorter: sorteColum(`calcWeight6`, true),
  },
]

